module.exports = __webpack_public_path__ + "img/icon-close.e0a567d2.svg";